export class UnlockPersonaRequest {
  public idPersona!: number
}
